import styled from 'styled-components';

export const WrapperVerificationCode = styled.div`
  width: max-content;
  margin: 0 auto;
`;

export const WrapperVerificationCodeSpaces = styled.div<{
  status?: 'DEFAULT' | 'ERROR' | 'FINISH' | 'SUCCESS';
}>`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;

  > button {
    display: flex;
    width: 24px;
    height: 24px;
    padding: 4px;
    justify-content: center;
    align-items: center;
    color: ${({ status }) =>
      status === 'SUCCESS'
        ? '#007f38'
        : status === 'ERROR' || status === 'FINISH'
        ? '#e8212b'
        : '#7a959f'};

    &:disabled {
      cursor: default;
    }
  }
`;

export const WrapperVerificationCodeInputs = styled.div<{
  status?: 'DEFAULT' | 'ERROR' | 'FINISH' | 'SUCCESS';
}>`
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;

  > input {
    height: 40px;
    width: 40px;
    padding: 0;
    outline: none;
    border-radius: 4px;
    text-align: center;
    background-color: #ffffff;

    border: 1px solid
      ${({ status }) =>
        status === 'SUCCESS'
          ? '#007f38'
          : status === 'ERROR' || status === 'FINISH'
          ? '#e8212b'
          : '#7a959f'};

    color: ${({ status }) =>
      status === 'ERROR' || status === 'FINISH' ? '#e8212b' : '#161D1F'};

    &:focus {
      border: 1px solid #745ef6;
    }

    &::placeholder {
      color: #7a959f;
    }
  }
`;

export const WrapperVerificationCodeMessage = styled.div`
  width: calc(100% - 32px);
  align-items: flex-start;
  color: #e8212b;
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  margin-top: 4px;

  > span {
    font-size: 12px;
    line-height: 16px;
  }
`;
